export default __webpack_public_path__ + "static/media/Lille-Gris.9bda0e16.jpg";